import { SignalSource, SignalState } from "@/common/model";
import {
	createStatusBadge,
	StatusPill,
	type TagStatus,
} from "@/components/status-pill";

export const SignalStateColorMap: Record<SignalState, TagStatus> = {
	[SignalState.OK]: "success",
	[SignalState.FIRING]: "error",
	[SignalState.WARNING]: "warning",
	// Grey, like Unknown: neither is a verdict on health, and amber is kept for Warning.
	[SignalState.NO_DATA]: "default",
	[SignalState.UNKNOWN]: "default",
};

export const SignalStateLabelMap: Record<SignalState, string> = {
	[SignalState.OK]: "OK",
	[SignalState.FIRING]: "Firing",
	[SignalState.WARNING]: "Warning",
	[SignalState.NO_DATA]: "No data",
	[SignalState.UNKNOWN]: "Unknown",
};

/** Worst first: the order rows, groups and summaries sort by. */
export const SIGNAL_STATE_ORDER: SignalState[] = [
	SignalState.FIRING,
	SignalState.WARNING,
	SignalState.NO_DATA,
	SignalState.UNKNOWN,
	SignalState.OK,
];

const SignalStateBadgeBase = createStatusBadge(
	SignalStateColorMap,
	SignalStateLabelMap,
	{ pulseWhen: [SignalState.FIRING] },
);

/** A signal's live state, or a neutral "Checking…" pill while it is being read from its source. */
export function SignalStateBadge({ state }: { state?: SignalState | null }) {
	if (!state) return <StatusPill>Checking…</StatusPill>;
	return <SignalStateBadgeBase status={state} />;
}

export const SignalSourceLabelMap: Record<SignalSource, string> = {
	[SignalSource.CLOUD_WATCH]: "CloudWatch",
	[SignalSource.CLOUD_WATCH_METRIC]: "CloudWatch",
	[SignalSource.COGNITO_USERS]: "Cognito",
	[SignalSource.AWS_COST]: "Cost Explorer",
};
